import composeRichText from '@/client/services/richText/composeRichText'
import { EMPTY_RICH_TEXT_VALUE } from '@/client/services/richText/constants'
import type { SerializedRichText } from '@/client/services/richText/types'

import getMessageConfig from './getMessageConfig'
import type { MessageBody, MessageType } from './types'

export function getMessageRichText({
  type,
  body,
}: {
  type: MessageType | null
  body: MessageBody | null
}): SerializedRichText {
  const config = getMessageConfig({ type, body })

  if (config == null) {
    return EMPTY_RICH_TEXT_VALUE
  }

  if (config.type === 'embed-v1') {
    if (config.body.embed === 'assessment') {
      return composeRichText(ctx => ctx.text('[EMBEDDED ASSESSMENT]', { italic: true }))
    }

    return composeRichText(ctx => ctx.text('[EMBEDDED RESOURCE]', { italic: true }))
  }

  return config.body
}
